export const FETCH_CONSOLE_LOGS_LOADING = "FETCH_CONSOLE_LOGS_LOADING";
export const FETCH_CONSOLE_LOGS_SUCCESS = "FETCH_CONSOLE_LOGS_SUCCESS";
export const FETCH_CONSOLE_LOGS_FAILED = "FETCH_CONSOLE_LOGS_FAILED";
export const CLEAR_CONSOLE_LOGS = "CLEAR_CONSOLE_LOGS;";

export const FETCH_CONSOLE_LOG_COUNT_FAILED = "FETCH_CONSOLE_LOG_COUNT_FAILED";
export const FETCH_CONSOLE_LOGS_COUNT_SUCCESS =
  "FETCH_CONSOLE_LOGS_COUNT_SUCCESS";
export const FETCH_CONSOLE_LOGS_PAGE_LOADING =
  "FETCH_CONSOLE_LOGS_PAGE_LOADING";
